import { render, staticRenderFns } from "./approved-workloads.vue?vue&type=template&id=0080deef&scoped=true&"
import script from "./approved-workloads.vue?vue&type=script&lang=js&"
export * from "./approved-workloads.vue?vue&type=script&lang=js&"
import style0 from "./approved-workloads.vue?vue&type=style&index=0&id=0080deef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080deef",
  null
  
)

export default component.exports